import { Component, input } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { MenuService } from '../../services/menu.service';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-header',
  imports: [TegelModule, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  descHeader = input('Argon');
  constructor(private menu: MenuService) {}

  mobileMenuAction(): void {
    this.menu.setSignal(true);
  }
}
